import React from 'react'
import { peopleHave } from '../../utils'
import { Card } from '../Card'
import { Meaning, Metric } from '../CardParts'
import { Figure, ShareBar } from './parts'
import type { EngagementCardProps } from './parts'
import { cappedShare, changeFrom } from './utils'

export const AppCard = ({ data, points, since, footer, highlighted, onAbout }: EngagementCardProps) => {
  const { enrolled, early_days } = data.people
  const { claimed } = data.engagement.app
  const share = cappedShare(claimed, enrolled)

  return (
    <Card
      question="The Wealthbit app"
      title={appTitle({ share, claimed, earlyDays: early_days, since })}
      onAbout={onAbout}
      highlighted={highlighted}
      footer={{ text: footer, chip: 'Everyone enrolled included' }}
    >
      <Metric text={`App · share of ${enrolled} enrolled people who have set up the app`} />
      <Figure value={`${share}%`} label={`${peopleHave(claimed)} set up the app`} change={changeFrom(points, 'app', enrolled)} />
      <ShareBar share={share} channel="app" />
      <Meaning text="The Wealthbit app shows each person their financial snapshot and helps them set goals and a spending plan." />
    </Card>
  )
}

type TitleInput = { share: number; claimed: number; earlyDays: boolean; since: string }

const appTitle = ({ share, claimed, earlyDays, since }: TitleInput): string => {
  if (earlyDays && claimed > 0) return `${peopleHave(claimed)} already set up the app`
  if (share > 50) return 'Most enrolled people have set up the Wealthbit app'
  return `The Wealthbit app ${since}`
}
